import { replaceCategoryChildren } from 'utils/categories';
import {
  LOAD_ROOT_CATEGORIES,
  ROOT_CATEGORIES_LOADED,
  SYNC_FAILED,
  RESET_CATEGORIES,
  LOAD_CATEGORY,
  CATEGORY_LOADED,
  LOAD_SUBCATEGORIES,
  SUBCATEGORIES_LOADED,
  LOAD_ANCESTORS,
  ANCESTORS_LOADED,
  BUILD_ROOT_SUB_CATEGORIES_HIERARCHY,
  LOAD_ROOT_SUB_CATEGORIES,
  SET_ROOT_SUB_CATEGORIES,
  ROOT_SUB_CATEGORIES_SYNC_FAILED,
  LOADED_ROOT_SUB_CATEGORIES,
  RESET_SUB_CATEGORIES_ERROR
} from './actionTypes';

import { ICategoryState } from './types';

export const initialState: ICategoryState = {
  error: null,
  category: [],
  categoryLoaded: false,
  rootCategories: [],
  rootCategoriesLoaded: false,
  subcategories: [],
  errorSubCategories: {
    Tax: null,
    Merchandise: null,
  },
  rootSubCategories: {
    Tax: [],
    Merchandise: [],
  },
  loadedSubCategories: {
    Tax: false,
    Merchandise: false,
  },
  syncingSubCategories: {
    Tax: false,
    Merchandise: false,
  },
  subcategoriesLoaded: false,
  ancestors: {},
  syncing: false,
};

export const reducer = (state = initialState, action: { type: string; payload?: any }) => {
  switch (action.type) {
    case LOAD_CATEGORY:
      return { ...state, error: null, syncing: true };
    case CATEGORY_LOADED:
      return {
        ...state,
        error: null,
        category: action.payload,
        syncing: false,
        categoryLoaded: true,
      };
    case LOAD_ROOT_CATEGORIES:
      return { ...state, error: null, syncing: true };
    case ROOT_CATEGORIES_LOADED:
      return {
        ...state,
        error: null,
        rootCategories: action.payload,
        syncing: false,
        rootCategoriesLoaded: true,
      };
    case LOAD_SUBCATEGORIES:
      return { ...state, error: null, syncing: true };
    case SUBCATEGORIES_LOADED:
      return {
        ...state,
        error: null,
        subcategories: action.payload,
        syncing: false,
        subcategoriesLoaded: true,
      };
    case LOAD_ANCESTORS:
      return { ...state, error: null, syncing: true };
    case ANCESTORS_LOADED:
      for (const [key, value] of Object.entries(action.payload)) {
        if(!value){
          action.payload[key] = [{
            title:{
              locale:"en-US",
              value:key
            },
            nodeId: {nodeId: key},
            uncataloged:true
          }]
        }
      }
      return {
        ...state,
        error: null,
        ancestors: { ...state.ancestors, ...action.payload },
        syncing: false,
      };


    case RESET_CATEGORIES:
      return initialState;
    case SYNC_FAILED:
      return { ...state, syncing: false, error: action.payload };
    case ROOT_SUB_CATEGORIES_SYNC_FAILED:
      return {
        ...state,
        syncingSubCategories: { ...state.syncingSubCategories, [action.payload.root]: false },
        errorSubCategories: {
          ...state.errorSubCategories,
          [action.payload.root]: action.payload.error,
        },
        syncing: false,
      };

    case LOAD_ROOT_SUB_CATEGORIES:
      return {
        ...state,
        syncingSubCategories: { ...state.syncingSubCategories, [action.payload]: true },
        errorSubCategories: { ...state.errorSubCategories, [action.payload]: null },
      };

    case LOADED_ROOT_SUB_CATEGORIES:
      return {
        ...state,
        syncingSubCategories: { ...state.syncingSubCategories, [action.payload]: false },
        errorSubCategories: { ...state.errorSubCategories, [action.payload]: null },
        loadedSubCategories: { ...state.loadedSubCategories, [action.payload]: true },
      };

    case SET_ROOT_SUB_CATEGORIES: {
      return {
        ...state,
        rootSubCategories: {
          ...state.rootSubCategories,
          [action.payload.root]: action.payload.data,
        },
      };
    }

    case BUILD_ROOT_SUB_CATEGORIES_HIERARCHY:
      return {
        ...state,
        rootSubCategories: {
          ...state.rootSubCategories,
          [action.payload.root]: replaceCategoryChildren(
            action.payload.parentId,
            action.payload.subcategories,
            state.rootSubCategories[action.payload.root]
          ),
        },
        syncing: false,
      };
    case RESET_SUB_CATEGORIES_ERROR:
      return {
        ...state,
        errorSubCategories: {
          Tax: null,
          Merchandise: null,
        },
      }
    default:
      return state;
  }
};
